import { bridge } from "@multiweb/reactCore/bridge";
import { IconCode } from "@multiweb/types/contracts";
import { CanRenderEmptyDecider, CanRenderEncryptedDecider } from "./types";

const { isNullOrEmpty, stringToEnumValue } = bridge;

/** Rozhoduje o tom, jestli se má atribut vyrenderovat jako zašifrovaný */
export const defaultCanRenderEncrypted: CanRenderEncryptedDecider = (record, info) =>
    !!(record.encrypted?.value && info.encryptingAlowed);

/** Rozhoduje o tom, jestli se atribut vyrenderuje, podle toho jestli má neprázdnou hodnotu */
export const defaultCanRenderEmpty: CanRenderEmptyDecider = (record, info) =>
    isNullOrEmpty(record[info.attributeName.toLowerCase()]?.value);

/** Rozhoduje o tom, jestli se má vyrenderovat ikona podle toho, jestli se jedná o platnou hodnotu enumu IconCode */
export const defaultIconCanRenderEmpty: CanRenderEmptyDecider = (record, info) =>
    isNullOrEmpty(record[info.attributeName.toLowerCase()]?.value)
    || stringToEnumValue(IconCode, record[info.attributeName.toLowerCase()]?.value ?? "") === undefined;
